import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Grid2,
  Container,
  useTheme,
  Divider,
  LinearProgress,
  Chip,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CustomTypography from "../../../components/common/form/CustomTypography";
import AppButton from "../../../components/common/buttons/AppButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SummaryIcon from "../../../../assets/reloadicon.png";
import PrintInwardicon from "../../../../assets/printinward.png";
import QCrejectionIcon from "../../../../assets/rawqc.png";
import RawInwardIcon from "../../../../assets/rawinward.png";
import QCrejectionIcon2 from "../../../../assets/setting.png";
import PrintOutwardicon from "../../../../assets/outward.png";
import vendorIcon from "../../../../assets/vendoricon.png";
import FormTextField from "../../../components/common/form/FormTextField";
import CustomTextField from "../../../components/common/textFields/TextField";
import { useStores } from "../../../../use-stores";
import DatePicker2 from "../../../components/common/textFields/DatePicker2";
import dayjs from "dayjs";
import AppSearchDropDown2 from "../../../components/common/filter/AppSearchDropdown2";
import { useNotification } from "../../../../utils/NotificationsContext";
import SummaryDrawer from "../../../components/common/summary/AppSummary";
import UploadIcon from "../../../../assets/uploadimg.png";
import ImageUploadDialog from "../../../components/common/upload/ImageUploadDialog";
import { observer } from "mobx-react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  PrintInwardDetailsReq,
  PrintInwardQcReq,
  PrintOutwardReq,
  RawInwardDetailsReq,
  RawInwardQcReq,
  VendorInvoice,
  VendorInvoiceType,
} from "../../../../models/ProjectManagement/InventoryOpsRequests";
import ImageAPI from "../../../../api/ImageAPI";
import ImageCarousel from "../../../components/common/carousel/ImageCarousel";
import ImageGalleryWithDialog from "../../../components/common/carousel/ImageGalleryWithDialog";
import { sizeLabelMap } from "../../../../models/ProjectManagement/SizeMix";
import SingleInput from "../../../components/common/pop-up/SingleInput";
import PopupGallery from "../../../components/common/carousel/ImageGalleryDilog";

import InvoiceInformationPopup from "./InvoiceInformationPopup";
import { FilterValue } from "../../../../models/Filters/FilterValue";
import AppDropDown from "../../../components/common/filter/AppDropDown";

const InventoryOpsDetails: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const projectId = Number(searchParams.get("project-id"));
  const productId = Number(searchParams.get("product-id"));
  const theme = useTheme();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSummaryOpen, setSummaryOpen] = useState(false);
  const [openQcPopup, setOpenQcPopup] = useState(false);
  const [openPrintQcPopup, setOpenPrintQcPopup] = useState(false);
  const [openHoldDialog, setOpenHoldDialog] = useState(false);
  const [isInvoicePopupOpen, setIsInvoicePopupOpen] = useState<boolean>(false);
  const [selectedInwardId, setSelectedInwardId] = useState<
    number | null | undefined
  >(null);
  const [selectedInvoiceType, setSelectedInvoiceType] =
    useState<VendorInvoiceType | null>(null);
  const [openPrintInwardHoldPopup, setOpenPrintInwardHoldPopup] =
    useState<boolean>(false);
  const { projectInventoryOpsStore, shipmentStore, warehouseStore } =
    useStores();

  const [isPopupGalleryOpen, setIsPopupGalleryOpen] = useState(false);
  const [isPopupGalleryOpenForRawInward, setIsPopupGalleryOpenForRawInward] =
    useState(false);

  useEffect(() => {
    document.body.classList.add("white-background");

    return () => {
      document.body.classList.remove("white-background");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDetails = () => {
    if (warehouseStore.warehouses.length === 0) {
      warehouseStore.searchWarehouse().catch((err) => {
        console.error(err);
      });
    }

    projectInventoryOpsStore
      .getProjectInventoryOpsProductDetails(projectId, Number(productId))
      .then(() => {
        const poIdFromUrl = Number(searchParams.get("po-id"));
        const allPOs =
          projectInventoryOpsStore.productDetailsBody.purchase_orders || [];
        const matchedPO = allPOs.find((po) => po.id === poIdFromUrl);

        if (matchedPO) {
          projectInventoryOpsStore.setCurrentPoDetails(matchedPO.id);
        } else if (allPOs.length > 0) {
          projectInventoryOpsStore.setCurrentPoDetails(allPOs[0].id);
          const params = new URLSearchParams(location.search);
          params.set("po-id", String(allPOs[0].id));
          navigate(`?${params.toString()}`, { replace: true });
        }
      })
      .catch((err) => {
        showError(
          "Error Occurred",
          err.response.data.message ||
            "Failed to fetch data, please try again later",
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchSummary = () => {
    setIsLoading(true);
    projectInventoryOpsStore
      .getSummary(projectId, Number(productId))
      .then((res) => {})
      .catch((err) => {
        showError(
          "Error Occurred",
          err.response?.data?.message ||
            "Failed to fetch data, please try again later",
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);

    if (projectId) {
      fetchSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  useEffect(() => {
    setIsLoading(true);

    if (projectId) {
      fetchDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  useEffect(() => {
    getProjectInventoryOpsProduct(projectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProjectInventoryOpsProduct = (projectId: number) => {
    setIsLoading(true);
    projectInventoryOpsStore
      .getProjectInventoryOpsDetails(projectId)
      .finally(() => setIsLoading(false));
  };

  const handleNavigation = (direction: "back" | "forward") => {
    if (
      !projectInventoryOpsStore.inventoryRequestBody.products ||
      projectInventoryOpsStore.inventoryRequestBody.products.length === 0
    )
      return;

    const productList = projectInventoryOpsStore.inventoryRequestBody.products;
    const currentIndex = productList.findIndex(
      (product) => product.id === Number(productId),
    );

    if (currentIndex === -1) return;

    let newIndex = currentIndex;

    if (direction === "back") {
      newIndex = currentIndex > 0 ? currentIndex - 1 : productList.length - 1;
    } else {
      newIndex = currentIndex < productList.length - 1 ? currentIndex + 1 : 0;
    }

    const newProduct = productList[newIndex];

    navigate(
      `/projects/inventory-ops-details?project-id=${projectId}&product-id=${newProduct.id}`,
    );
  };

  const handleUpload1 = async (files: File[]) => {
    setIsLoading(true);
    if (files.length > 0) {
      try {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_raw_inward_qc_images: [
            ...(projectInventoryOpsStore.currentPoDetails
              .temp_raw_inward_qc_images || []),
            ...files,
          ],
        });

        setOpenQcPopup(false);
      } catch (error) {
        showError(
          "Error occurred",
          "Something went wrong! Please try again later.",
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleUpload2 = async (files: File[]) => {
    setIsLoading(true);
    if (files.length > 0) {
      try {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_print_inward_qc_images: [
            ...(projectInventoryOpsStore.currentPoDetails
              .temp_print_inward_qc_images || []),
            ...files,
          ],
        });
        setOpenPrintQcPopup(false);
      } catch (error) {
        showError(
          "Error occurred",
          "Something went wrong! Please try again later.",
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const uploadImage = async (
    files: File[],
    category: string,
  ): Promise<string[]> => {
    if (files.length > 0) {
      const imageAPI = new ImageAPI();
      try {
        const uploadedUrls = await imageAPI.uploadImage(
          files,
          "product-images",
        );
        return uploadedUrls;
      } catch (err: any) {
        showError(
          "Error occurred",
          err?.response?.data?.message ||
            "Something went wrong! Please try again later.",
        );
      }
    }
    return [];
  };

  const saveRawInwardDetails = async (markReceived?: boolean) => {
    const body: RawInwardDetailsReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      raw_inward_received_qty: markReceived
        ? 0
        : (projectInventoryOpsStore.currentPoDetails.temp_raw_inward_quantity ??
          0),
      raw_inward_mark_received: markReceived,
      raw_inward_id:
        projectInventoryOpsStore.currentPoDetails.raw_inward_id ?? undefined,
      raw_inward_qc_rejected_recieved_qty:
        projectInventoryOpsStore.currentPoDetails
          .temp_raw_inward_rejection_quantity ?? 0,
      warehouse_id:
        projectInventoryOpsStore.currentPoDetails.warehouse_id ?? null,
    };

    if (
      projectInventoryOpsStore.currentPoDetails.temp_raw_inward_rejection_reason
    ) {
      body.raw_inward_rejection_reason =
        projectInventoryOpsStore.currentPoDetails.temp_raw_inward_rejection_reason;
    }

    if (
      Array.isArray(
        projectInventoryOpsStore.currentPoDetails.temp_raw_inward_qc_images,
      ) &&
      projectInventoryOpsStore.currentPoDetails.temp_raw_inward_qc_images
        .length > 0
    ) {
      const uploadedImageUrls = await uploadImage(
        projectInventoryOpsStore.currentPoDetails.temp_raw_inward_qc_images,
        "products",
      );
      if (uploadedImageUrls.length > 0) {
        body.raw_inward_qc_images = uploadedImageUrls;
      }
    }

    projectInventoryOpsStore
      .updateRawInwardDetails(body)
      .then(() => {
        const newRawInwardQcStart = false;
        projectInventoryOpsStore.updateQcStartStatus(
          "raw_inward_in_progress",
          newRawInwardQcStart,
        );

        if (markReceived) {
          projectInventoryOpsStore.fetchVendorInvoices(
            projectInventoryOpsStore.currentPoDetails.raw_inward_id!,
            VendorInvoiceType.RAW_INWARD,
          );
        }

        fetchSummary();
      })
      .catch((err) => {
        showError(
          "Error Occurred",
          err.response.data.message ||
            "Failed to save data, please try again later",
        );
      });
  };

  const savePrintOutward = () => {
    if (
      !projectInventoryOpsStore.currentPoDetails.temp_print_outward_timeline
    ) {
      showError(
        "Error Occurred",
        "Print Due date is missing, please try again later",
      );
      return;
    }

    if (
      !projectInventoryOpsStore.currentPoDetails.temp_print_outward_printer_id
    ) {
      showError("Error Occurred", "Printer is missing, please select printer");
      return;
    }

    if (
      projectInventoryOpsStore.currentPoDetails.temp_print_outward_quantity ===
      null
    ) {
      showError("Error Occurred", "Print outward quantity is missing");
      return;
    }

    if (!projectInventoryOpsStore.currentPoDetails.raw_inward_id) {
      showError("Error Occurred", "Raw Inward is missing");
      return;
    }

    if (
      projectInventoryOpsStore.currentPoDetails.temp_print_outward_quantity !==
      null
    ) {
      const body: PrintOutwardReq = {
        order_id: projectId,
        product_id: Number(productId),
        po_id: projectInventoryOpsStore.currentPoDetails.po_id,
        raw_inward_id: projectInventoryOpsStore.currentPoDetails.raw_inward_id,
        printer_id:
          projectInventoryOpsStore.currentPoDetails
            .temp_print_outward_printer_id,
        print_outward_quantity:
          projectInventoryOpsStore.currentPoDetails
            .temp_print_outward_quantity ?? 0,
        print_outward_timeline:
          projectInventoryOpsStore.currentPoDetails.temp_print_outward_timeline,
      };

      projectInventoryOpsStore
        .updatePrintOutward(body)
        .then(() => {
          projectInventoryOpsStore.updateCurrentPoDetails({
            temp_print_outward_printer_id: null,
            temp_print_outward_printer_name: null,
            temp_print_outward_quantity: null,
            temp_print_outward_timeline: null,
          });
          projectInventoryOpsStore.getSummary(projectId, Number(productId));
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response.data.message ||
              "Failed to save data, please try again later",
          );
        });
    }
  };

  const savePrintInwardDetails = async (markReceived?: boolean) => {
    const body: PrintInwardDetailsReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      print_outward_id:
        projectInventoryOpsStore.currentPoDetails.print_outward_id,
      print_inward_quantity: markReceived
        ? 0
        : (projectInventoryOpsStore.currentPoDetails
            .temp_print_inward_quantity ?? 0),
      print_inward_mark_received: markReceived,
      print_inward_rejection_quantity:
        projectInventoryOpsStore.currentPoDetails
          .temp_print_inward_rejection_quantity ?? 0,

      print_inward_id:
        projectInventoryOpsStore.currentPoDetails.print_inward_id ?? undefined,
    };

    if (
      projectInventoryOpsStore.currentPoDetails
        .temp_print_inward_rejection_reason
    ) {
      body.print_inward_rejection_reason =
        projectInventoryOpsStore.currentPoDetails.temp_print_inward_rejection_reason;
    }

    if (
      Array.isArray(
        projectInventoryOpsStore.currentPoDetails.temp_print_inward_qc_images,
      ) &&
      projectInventoryOpsStore.currentPoDetails.temp_print_inward_qc_images
        .length > 0
    ) {
      const uploadedImageUrls = await uploadImage(
        projectInventoryOpsStore.currentPoDetails.temp_print_inward_qc_images,
        "products",
      );
      if (uploadedImageUrls.length > 0) {
        body.print_inward_qc_images = uploadedImageUrls;
      }
    }

    projectInventoryOpsStore
      .updatePrintInwardDetails(body)
      .then(() => {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_print_inward_quantity: null,
        });
        const newPrintInwardQcStart = false;
        projectInventoryOpsStore.updateQcStartStatus(
          "print_inward_in_progress",
          newPrintInwardQcStart,
        );
      })
      .then(() => {
        projectInventoryOpsStore.getSummary(projectId, Number(productId));
      })
      .catch((err) => {
        showError(
          "Error Occurred",
          err.response.data.message ||
            "Failed to save data, please try again later",
        );
      });
  };

  const handleStartStopRawInwardQc = () => {
    const body: RawInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      raw_inward_id:
        projectInventoryOpsStore.currentPoDetails.raw_inward_id ?? 0,
    };

    if (projectInventoryOpsStore.currentPoDetails.raw_inward_qc_on_hold) {
      // Resume QC
      setIsLoading(true);
      body.raw_inward_qc_on_hold = false;
      body.raw_inward_qc_reason_for_hold = null;
      projectInventoryOpsStore
        .startRawInwardQc(body)
        .then(() => {
          projectInventoryOpsStore.updateCurrentPoDetails({
            raw_inward_qc_on_hold: false,
            temp_raw_inward_qc_hold_reason: "",
          });
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response?.data?.message ||
              "Failed to resume QC, please try again later",
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (
      !projectInventoryOpsStore.currentPoDetails.raw_inward_in_progress
    ) {
      // Start QC
      setIsLoading(true);
      projectInventoryOpsStore
        .startRawInwardQc(body)
        .then(() => {
          const newRawInwardQcStart =
            !projectInventoryOpsStore.currentPoDetails.raw_inward_in_progress;
          projectInventoryOpsStore.updateQcStartStatus(
            "raw_inward_in_progress",
            newRawInwardQcStart,
          );

          projectInventoryOpsStore.updateCurrentPoDetails({
            temp_raw_inward_qc_hold_reason: "",
          });
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response?.data?.message ||
              "Failed to start QC, please try again later",
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // Open hold dialog
      projectInventoryOpsStore.updateCurrentPoDetails({
        temp_raw_inward_qc_hold_reason: "",
      });
      setOpenHoldDialog(true);
    }
  };

  const handleSaveInvoiceDetails = async (
    inwardId: number,
    type: VendorInvoiceType,
    invoiceReceived: boolean,
    invoices?: VendorInvoice[],
  ) => {
    try {
      if (inwardId && type) {
        await Promise.all([
          projectInventoryOpsStore.updateInvoiceMarkedAsReceived(
            inwardId,
            type,
            invoiceReceived,
          ),
          projectInventoryOpsStore.addUpdateVendorInvoices(
            inwardId,
            type,
            invoices ?? [],
          ),
        ]);
        showSuccess(
          `Invoice marked as ${
            invoiceReceived ? "received" : "not received"
          } successfully! Invoice(s) saved successfully!`,
        );
      } else {
        showSuccess(
          `Invoice marked as ${
            invoiceReceived ? "received" : "not received"
          } successfully!`,
        );
      }
      setIsInvoicePopupOpen(false);
    } catch (error: any) {
      showError(
        "Error Occurred",
        error.response.data.message ||
          "Failed to save invoice details, please try again later",
      );
    }
  };

  const fetchVendorInvoices = (
    inwardId: number | null | undefined,
    type: VendorInvoiceType,
  ) => {
    if (inwardId && type) {
      projectInventoryOpsStore
        .fetchVendorInvoices(inwardId, type)
        .then(() => {
          handleOpenInvoicePopup(inwardId, type);
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response.data.message ||
              "Failed to fetch invoices, please try again later",
          );
        });
    }
  };

  const handleOpenInvoicePopup = (
    inwardId: number,
    type: VendorInvoiceType,
  ) => {
    setSelectedInwardId(inwardId);
    setSelectedInvoiceType(type);
    setIsInvoicePopupOpen(true);
  };

  const handleCloseInvoicePopup = () => {
    setIsInvoicePopupOpen(false);
  };

  const handleStartStopPrintInwardQc = () => {
    const body: PrintInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      print_inward_id:
        projectInventoryOpsStore.currentPoDetails.print_inward_id ?? 0,
    };

    if (projectInventoryOpsStore.currentPoDetails.print_inward_qc_on_hold) {
      setIsLoading(true);
      body.print_inward_qc_on_hold = false;
      body.print_inward_qc_reason_for_hold = null;

      projectInventoryOpsStore
        .startPrintInwardQc(body)
        .then(() => {
          projectInventoryOpsStore.updateCurrentPoDetails({
            print_inward_qc_on_hold: false,
            temp_print_inward_qc_reason_for_hold: "",
          });
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response.data.message ||
              "Failed to save data, please try again later",
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (
      !projectInventoryOpsStore.currentPoDetails.print_inward_in_progress
    ) {
      setIsLoading(true);
      projectInventoryOpsStore
        .startPrintInwardQc(body)
        .then(() => {
          const newValue =
            !projectInventoryOpsStore.currentPoDetails.print_inward_in_progress;
          projectInventoryOpsStore.updateQcStartStatus(
            "print_inward_in_progress",
            newValue,
          );

          projectInventoryOpsStore.updateCurrentPoDetails({
            temp_print_inward_qc_reason_for_hold: "",
          });
        })
        .catch((err) => {
          showError(
            "Error Occurred",
            err.response.data.message ||
              "Failed to save data, please try again later",
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      projectInventoryOpsStore.updateCurrentPoDetails({
        temp_print_inward_qc_reason_for_hold: "",
      });
      setOpenPrintInwardHoldPopup(true);
    }
  };

  const handleHoldQc = async () => {
    const holdReason =
      projectInventoryOpsStore.currentPoDetails
        .temp_raw_inward_qc_hold_reason || "";
    if (!holdReason.trim()) {
      showError("Error Occurred", "Reason for holding is mandatory");
      return;
    }

    const body: RawInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      raw_inward_id:
        projectInventoryOpsStore.currentPoDetails.raw_inward_id ?? 0,
      raw_inward_qc_on_hold: true,
      raw_inward_qc_reason_for_hold: holdReason,
    };
    setIsLoading(true);
    projectInventoryOpsStore
      .startRawInwardQc(body)
      .then(() => {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_raw_inward_qc_hold_reason: "",
          raw_inward_qc_on_hold: true,
        });
        projectInventoryOpsStore.getSummary(projectId, Number(productId));
      })
      .finally(() => {
        setOpenHoldDialog(false);
        setIsLoading(false);
      });
  };

  const handleHoldPrintInwardQc = async () => {
    const holdReason =
      projectInventoryOpsStore.currentPoDetails
        ?.temp_print_inward_qc_reason_for_hold;

    if (!holdReason || holdReason === "" || holdReason?.length === 0) {
      showError("Error Occurred", "Reason for holding is mandatory");
      return;
    }

    const body: PrintInwardQcReq = {
      order_id: projectId,
      product_id: Number(productId),
      po_id: projectInventoryOpsStore.currentPoDetails.po_id,
      print_inward_id:
        projectInventoryOpsStore.currentPoDetails.print_inward_id ?? 0,
      print_inward_qc_on_hold: true,
      print_inward_qc_reason_for_hold: holdReason,
    };

    setIsLoading(true);
    projectInventoryOpsStore
      .startPrintInwardQc(body)
      .then(() => {
        projectInventoryOpsStore.updateCurrentPoDetails({
          temp_print_inward_qc_reason_for_hold: "",
          print_inward_qc_on_hold: true,
        });
        projectInventoryOpsStore.getSummary(projectId, Number(productId));
      })
      .catch((err) => {
        showError(
          "Error Occurred",
          err.response.data.message ||
            "Failed to save data, please try again later",
        );
      })
      .finally(() => {
        setOpenPrintInwardHoldPopup(false);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Backdrop
        sx={(theme) => ({
          color: theme.palette.customColors.white,
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container
        maxWidth="xl"
        sx={{
          pl: { xl: "6.25rem", lg: "4.063rem" },
          pr: { xl: "6.25rem", lg: "4.063rem" },
        }}
      >
        <Box sx={{ margin: "auto", mb: "1.625rem" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
              color: theme.palette.customColors.greyTextColor,
              mb: 2,
              mt: 2,
              maxWidth: "3.75rem",
              paddingLeft: { xl: 3.2, lg: 3.2, md: 3.2, sm: 0, xs: 0 },
              "&:hover, &:active": {
                color: theme.palette.customColors.greyTextColor,
              },
            }}
            onClick={() => {
              navigate(`/projects/${projectId}?tab_index=2`);
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "1rem" }} />
            <span style={{ fontSize: "0.875rem", fontWeight: "600" }}>
              Back
            </span>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              position: "relative",
              width: "100%",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (max-width: 900px)": {
                  display: "none",
                },
              }}
            >
              <IconButton
                onClick={() => handleNavigation("back")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) === 0
                }
                sx={{
                  mt: 1,
                  ml: { xs: "-26px", lg: "-26px", md: "-26px" },
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "4px" }}
                />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                flexGrow: 1,
              }}
            >
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CustomTypography
                    variant="heading2"
                    color={theme.palette.customColors.greyTextColor}
                  >
                    #{projectId}
                  </CustomTypography>
                  {projectInventoryOpsStore?.inventoryRequestBody?.label && (
                    <Chip
                      label={
                        projectInventoryOpsStore.inventoryRequestBody.label
                      }
                      size="small"
                      sx={{ pl: 2, pr: 2, fontSize: "12px" }}
                    />
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 1,
                  }}
                >
                  <Box>
                    <CustomTypography variant="heading2">
                      {
                        projectInventoryOpsStore.productDetailsBody.product
                          ?.name
                      }
                      <span
                        style={{
                          color: theme.palette.customColors.purple,
                          marginLeft: "1rem",
                        }}
                      >
                        (
                        {
                          projectInventoryOpsStore.productDetailsBody.product
                            ?.quantity
                        }
                        )
                      </span>
                    </CustomTypography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      <CustomTypography
                        variant="heading7"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ marginRight: 1 }}>
                          <img
                            src={vendorIcon}
                            alt="Raw Inward Icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </Box>
                        Vendor:
                        <span
                          style={{
                            color: theme.palette.customColors.greyDarkborder,
                            paddingLeft: 5,
                          }}
                        >
                          {projectInventoryOpsStore.currentPoDetails
                            ?.vendor_name || ""}
                        </span>
                      </CustomTypography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ paddingTop: 3 }}>
                <CustomTypography
                  variant="heading7"
                  style={{ marginBottom: 8 }}
                  color={theme.palette.customColors.greyTextColor}
                >
                  Progress
                </CustomTypography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={
                      projectInventoryOpsStore.productDetailsBody.progress || 0
                    }
                    sx={{
                      height: 10,
                      width: 200,
                      borderRadius: 5,
                      backgroundColor:
                        theme.palette.customColors.grayBackGroundColor,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: theme.palette.customColors.purple,
                      },
                    }}
                  />
                  <CustomTypography
                    variant="heading7"
                    color={theme.palette.customColors.greyTextColor}
                  >
                    {projectInventoryOpsStore.productDetailsBody.progress}%{" "}
                  </CustomTypography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (max-width: 900px)": {
                  display: "none",
                },
              }}
            >
              <IconButton
                onClick={() => handleNavigation("forward")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) ===
                  projectInventoryOpsStore.inventoryRequestBody.products
                    ?.length -
                    1
                }
                sx={{
                  mt: 3,
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "2px" }}
                />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mt: 2,
              pl: { xl: "1.8rem", lg: "1.8rem", md: "1.8rem" },
            }}
          >
            {projectInventoryOpsStore.currentPoDetails?.raw_inward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Raw Inward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.raw_inward_id +
                    " |"}
                </span>
              </CustomTypography>
            )}

            {projectInventoryOpsStore.currentPoDetails?.print_outward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Print Outward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.print_outward_id +
                    " |"}
                </span>
              </CustomTypography>
            )}

            {projectInventoryOpsStore.currentPoDetails?.print_inward_id && (
              <CustomTypography
                variant="heading8"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Print Inward -
                <span
                  style={{
                    color: theme.palette.customColors.greyDarkborder,
                    paddingLeft: 5,
                  }}
                >
                  {projectInventoryOpsStore.currentPoDetails.print_inward_id}
                </span>
              </CustomTypography>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              "@media (min-width: 900px)": {
                display: "none",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton
                onClick={() => handleNavigation("back")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) === 0
                }
                sx={{
                  mt: 1,
                  ml: { xs: "-26px", lg: "-26px", md: "-26px" },
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "4px" }}
                />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton
                onClick={() => handleNavigation("forward")}
                disabled={
                  projectInventoryOpsStore.checkProductIndex(
                    Number(productId),
                  ) ===
                  projectInventoryOpsStore.inventoryRequestBody.products
                    ?.length -
                    1
                }
                sx={{
                  mt: 1,
                  border: `2px solid ${theme.palette.customColors.disabledBorderColor}`,
                  width: "35px",
                  height: "35px",
                  display: { xs: "flex", md: "inline-flex" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: "1rem", md: "1rem", sm: "1rem" } }}
                  style={{ marginLeft: "2px" }}
                />
              </IconButton>
            </Box>
          </Box>
        </Box>

        <Box sx={{ margin: "auto" }} pl={3} pr={3}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 3,
                maxWidth: "70%",
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
              }}
            >
              {projectInventoryOpsStore.productDetailsBody.purchase_orders?.map(
                (po) => (
                  <Box
                    key={po.id}
                    onClick={() => {
                      projectInventoryOpsStore.setCurrentPoDetails(po.id);
                      const params = new URLSearchParams(location.search);
                      params.set("po-id", String(po.id));
                      navigate(`?${params.toString()}`, { replace: true });
                    }}
                    sx={{
                      cursor: "pointer",
                      minWidth: "6rem",
                      textAlign: "center",
                      borderBottom:
                        projectInventoryOpsStore.currentPoDetails?.po_id ===
                        po.id
                          ? `2px solid ${theme.palette.customColors.purple}`
                          : "none",
                      paddingBottom: "0.6rem",
                    }}
                  >
                    <CustomTypography
                      variant="heading5"
                      style={{
                        color:
                          projectInventoryOpsStore.currentPoDetails?.po_id ===
                          po.id
                            ? theme.palette.customColors.purple
                            : "black",
                      }}
                    >
                      PO: {po.id}
                    </CustomTypography>
                  </Box>
                ),
              )}
            </Box>

            <>
              <Box
                onClick={() => setSummaryOpen(true)}
                sx={{ cursor: "pointer" }}
              >
                <CustomTypography
                  variant="heading6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: theme.palette.customColors.pinkDark,
                  }}
                >
                  <Box>
                    <img src={SummaryIcon} alt="Summary" />
                  </Box>
                  Summary
                </CustomTypography>
              </Box>
              <SummaryDrawer
                isOpen={isSummaryOpen}
                onClose={() => setSummaryOpen(false)}
                summaryData={
                  Array.isArray(projectInventoryOpsStore.summaryDetails)
                    ? projectInventoryOpsStore.summaryDetails
                    : [projectInventoryOpsStore.summaryDetails]
                }
              />
            </>
          </Box>

          <>
            <Divider sx={{ mb: 5 }} />

            <Grid2
              container
              spacing={{ lg: 10, xs: 4 }}
              columns={{ lg: 12, xs: 12 }}
              sx={{
                display: { xl: "flex", lg: "flex", md: "block" },
                justifyContent: { xl: "space-between", lg: "space-between" },
              }}
            >
              <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                {projectInventoryOpsStore.productDetailsBody ? (
                  <Box>
                    <CustomTypography variant="heading5">
                      Product Images
                    </CustomTypography>

                    <ImageCarousel
                      images={
                        projectInventoryOpsStore.productDetails?.product
                          ?.image_urls
                          ? projectInventoryOpsStore.productDetails?.product
                              ?.image_urls
                          : projectInventoryOpsStore.productDetails?.product
                              ?.image_url
                      }
                    />
                  </Box>
                ) : (
                  <Box>
                    <CustomTypography variant="heading5">
                      Product Image
                    </CustomTypography>

                    <Box mt={2.5}>
                      <Box
                        sx={{
                          height: "24rem",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor:
                            theme.palette.customColors.greyBackground,
                        }}
                      >
                        <CustomTypography variant="heading6">
                          NO IMAGES FOUND
                        </CustomTypography>
                      </Box>
                    </Box>
                  </Box>
                )}

                <ImageGalleryWithDialog
                  images={
                    projectInventoryOpsStore?.currentPoDetails
                      ?.raw_inward_qc_images
                  }
                  onImageClick={() =>
                    setIsPopupGalleryOpenForRawInward(
                      !isPopupGalleryOpenForRawInward,
                    )
                  }
                  title="1st QC Images"
                  imageKey="image_url"
                  idKey="id"
                  initialVisibleCount={3}
                  emptyMessage="QC IMAGES NOT FOUND"
                />
                <PopupGallery
                  key={"rawInwardQc"}
                  open={isPopupGalleryOpenForRawInward}
                  onClose={() => setIsPopupGalleryOpenForRawInward(false)}
                  images={
                    projectInventoryOpsStore?.currentPoDetails?.raw_inward_qc_images?.map(
                      (img) => ({ id: img.id, src: img.image_url }),
                    ) || []
                  }
                  title={"1st QC Images"}
                  handleDeleteImage={(id) => {
                    projectInventoryOpsStore.deleteRawInwardQCImg(id);
                  }}
                />
              </Grid2>

              <Grid2
                size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
              >
                <Box>
                  <Box>
                    <Box display={"flex"} justifyContent={"space-between"}>
                      <CustomTypography
                        variant="heading5"
                        style={{
                          marginBottom: 20,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ marginRight: 1 }}>
                          <img
                            src={RawInwardIcon}
                            alt="Raw Inward Icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </Box>
                        Raw Inward
                        <span
                          style={{
                            color: theme.palette.customColors.greyTextColor,
                            paddingLeft: "10px",
                          }}
                        >
                          {`(${
                            projectInventoryOpsStore.currentPoDetails
                              ?.raw_inward_quantity || 0
                          }/
                       ${
                         projectInventoryOpsStore.currentPoDetails
                           ?.product_po_quantity || 0
                       })`}
                        </span>
                      </CustomTypography>

                      <Box display={"flex"} alignItems={"center"} gap={2}>
                        <AppButton
                          label={
                            projectInventoryOpsStore.currentPoDetails
                              ?.raw_inward_mark_received
                              ? "Received"
                              : "Received"
                          }
                          variant="primary"
                          onClick={() => saveRawInwardDetails(true)}
                          customStyles={{
                            fontSize: "14px",
                            textTransform: "none",
                            maxHeight: "28px",
                            minHeight: "28px",
                            backgroundColor: projectInventoryOpsStore
                              .currentPoDetails?.raw_inward_mark_received
                              ? theme.palette.customColors.greenLight
                              : "",
                          }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            projectInventoryOpsStore?.currentPoDetails
                              ?.raw_inward_mark_received ||
                            (projectInventoryOpsStore?.currentPoDetails
                              ?.print_inward_quantity || 0) -
                              (projectInventoryOpsStore?.currentPoDetails
                                ?.print_inward_rejection_quantity || 0) >=
                              (projectInventoryOpsStore?.currentPoDetails
                                ?.product_po_quantity || 0)
                          }
                        />

                        <Box>
                          <AppButton
                            key={
                              projectInventoryOpsStore.currentPoDetails
                                .raw_inward_qc_on_hold
                                ? "resume_raw_inward_qc"
                                : projectInventoryOpsStore.currentPoDetails
                                      .raw_inward_in_progress
                                  ? "hold_raw_inward_qc"
                                  : "start_raw_inward_qc"
                            }
                            label={
                              projectInventoryOpsStore.currentPoDetails
                                .raw_inward_qc_on_hold
                                ? "Resume QC"
                                : projectInventoryOpsStore.currentPoDetails
                                      .raw_inward_in_progress
                                  ? "Hold QC"
                                  : "Start QC"
                            }
                            variant="primary"
                            onClick={handleStartStopRawInwardQc}
                            customStyles={{
                              right: "4px",
                              fontSize: "14px",
                              textTransform: "none",
                              maxHeight: "28px",
                              minHeight: "28px",
                            }}
                            disabled={
                              projectInventoryOpsStore.inventoryRequestBody
                                .archived === 1
                            }
                          />
                        </Box>
                        <Box>
                          {/* <AppButton
                            key={"raw_inward_qc_invoice_details"}
                            label={"Invoice Details"}
                            variant="primary"
                            onClick={() =>
                              fetchVendorInvoices(
                                projectInventoryOpsStore.currentPoDetails
                                  .raw_inward_id,
                                VendorInvoiceType.RAW_INWARD
                              )
                            }
                            customStyles={{
                              right: "4px",
                              fontSize: "14px",
                              textTransform: "none",
                              maxHeight: "28px",
                              minHeight: "28px",
                            }}
                            disabled={
                              projectInventoryOpsStore.currentPoDetails
                                ?.raw_inward_id === undefined ||
                              projectInventoryOpsStore.inventoryRequestBody
                                .archived === 1
                            }
                          /> */}
                        </Box>
                      </Box>
                    </Box>
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 15 }}
                    >
                      Warehouse
                    </CustomTypography>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        marginBottom: 2,
                      }}
                    >
                      <AppDropDown
                        isMultiSelect={false}
                        title=""
                        list={warehouseStore.warehouses.map((warehouse) => ({
                          id: warehouse.id,
                          value: warehouse.identifier,
                        }))}
                        value={
                          projectInventoryOpsStore.currentPoDetails
                            ?.warehouse_id
                        }
                        onSingleSelectionChange={(id: string, name: string) => {
                          projectInventoryOpsStore.updateCurrentPoDetails({
                            warehouse_id: id,
                            warehouse_identifier: name,
                          });
                        }}
                        fontSize={"12px"}
                        disabled={
                          projectInventoryOpsStore.inventoryRequestBody
                            .archived === 1
                        }
                      />
                    </Box>
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 15 }}
                    >
                      Quantity Received
                    </CustomTypography>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        marginBottom: 2,
                      }}
                    >
                      <CustomTextField
                        allowDecimalValue={false}
                        allowNegativeValue={false}
                        borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                        value={
                          projectInventoryOpsStore.currentPoDetails
                            ?.temp_raw_inward_quantity || ""
                        }
                        placeholder="00"
                        width="100%"
                        type="number"
                        onChange={(e) => {
                          projectInventoryOpsStore.updateCurrentPoDetails({
                            temp_raw_inward_quantity: Number(e.target.value),
                          });
                        }}
                        disabled={
                          projectInventoryOpsStore.currentPoDetails
                            ?.raw_inward_mark_received === undefined ||
                          projectInventoryOpsStore.inventoryRequestBody
                            .archived === 1
                        }
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 2,
                        marginTop: 5,
                        marginBottom: 3,
                      }}
                    >
                      <Box>
                        <CustomTypography
                          variant="heading5"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box sx={{ marginRight: 1 }}>
                            <img
                              src={QCrejectionIcon}
                              alt="Raw Inward Icon"
                              style={{ width: 24, height: 24 }}
                            />
                          </Box>
                          1st QC Rejection{" "}
                          <span
                            style={{
                              color: theme.palette.customColors.greyTextColor,
                              paddingLeft: "10px",
                            }}
                          >
                            {`(${
                              projectInventoryOpsStore.currentPoDetails
                                ?.raw_inward_rejection_quantity || 0
                            }/
                        ${
                          projectInventoryOpsStore.currentPoDetails
                            ?.product_po_quantity || 0
                        })`}
                          </span>
                        </CustomTypography>
                      </Box>
                    </Box>

                    <SingleInput
                      multiline={true}
                      required={true}
                      key={"raw_inward_popup"}
                      buttonMarginTop={0}
                      open={openHoldDialog}
                      type="text"
                      heading="Hold QC"
                      content="Please provide a reason for holding the QC process (mandatory)."
                      onSubmit={(reason) => {
                        projectInventoryOpsStore.updateCurrentPoDetails({
                          temp_raw_inward_qc_hold_reason: reason,
                        });
                        handleHoldQc();
                      }}
                      onClose={() => {
                        projectInventoryOpsStore.updateCurrentPoDetails({
                          temp_raw_inward_qc_hold_reason: "",
                        });
                        setOpenHoldDialog(false);
                      }}
                    />

                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <CustomTypography
                        variant="heading6"
                        color={theme.palette.customColors.greyTextColor}
                        style={{ marginBottom: 15 }}
                      >
                        Quantity Rejected
                      </CustomTypography>
                    </Box>
                    <CustomTextField
                      type="number"
                      allowDecimalValue={false}
                      allowNegativeValue={false}
                      borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                      value={
                        projectInventoryOpsStore.currentPoDetails
                          ?.temp_raw_inward_rejection_quantity || ""
                      }
                      placeholder="00"
                      width="100%"
                      onChange={(e) => {
                        projectInventoryOpsStore.updateCurrentPoDetails({
                          temp_raw_inward_rejection_quantity: Number(
                            e.target.value,
                          ),
                        });
                      }}
                      disabled={
                        projectInventoryOpsStore.inventoryRequestBody
                          .archived === 1 ||
                        !projectInventoryOpsStore.currentPoDetails
                          .raw_inward_in_progress ||
                        Boolean(
                          projectInventoryOpsStore.currentPoDetails
                            .raw_inward_qc_on_hold,
                        )
                      }
                    />
                    <CustomTypography
                      variant="heading6"
                      color={theme.palette.customColors.greyTextColor}
                      style={{ marginBottom: 15, marginTop: 20 }}
                    >
                      Rejection Reason
                    </CustomTypography>
                    <FormTextField
                      borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                      multiline
                      id="temp_raw_inward_rejection_reason"
                      sx={{
                        flexGrow: 1,
                        marginBottom: "0px",
                        "& .MuiInputBase-root": {
                          height: "100%",
                          alignItems: "start",
                          overflow: "auto",
                        },
                        "& .MuiInputBase-input": {
                          minHeight: "110px",
                          overflowY: "auto",
                          display: "block",
                        },
                      }}
                      value={
                        projectInventoryOpsStore.currentPoDetails
                          ?.temp_raw_inward_rejection_reason || ""
                      }
                      placeholder="Write the rejection reason"
                      onChange={(id, value) => {
                        projectInventoryOpsStore.updateCurrentPoDetails({
                          temp_raw_inward_rejection_reason: value,
                        });
                      }}
                      disabled={
                        projectInventoryOpsStore.inventoryRequestBody
                          .archived === 1 ||
                        !projectInventoryOpsStore.currentPoDetails
                          .raw_inward_in_progress ||
                        Boolean(
                          projectInventoryOpsStore.currentPoDetails
                            .raw_inward_qc_on_hold,
                        )
                      }
                    />

                    <AppButton
                      label={
                        <Box display={"flex"} alignItems="center">
                          {Boolean(
                            projectInventoryOpsStore.currentPoDetails
                              .raw_inward_in_progress,
                          ) && (
                            <img
                              src={UploadIcon}
                              alt="Upload Icon"
                              style={{ marginRight: 8 }}
                            />
                          )}
                          Upload Images
                        </Box>
                      }
                      onClick={() => setOpenQcPopup(true)}
                      variant="primary"
                      customStyles={{ width: "100%", marginTop: 3 }}
                      disabled={
                        projectInventoryOpsStore.inventoryRequestBody
                          .archived === 1 ||
                        !projectInventoryOpsStore.currentPoDetails
                          .raw_inward_in_progress ||
                        Boolean(
                          projectInventoryOpsStore.currentPoDetails
                            .raw_inward_qc_on_hold,
                        )
                      }
                    />
                    <ImageUploadDialog
                      open={openQcPopup}
                      onClose={() => setOpenQcPopup(false)}
                      onUpload={handleUpload1}
                      multiple={true}
                    />
                    <AppButton
                      label="Save Details/ Stop QC"
                      onClick={() => saveRawInwardDetails(false)}
                      fontSize="1rem"
                      variant="primary"
                      customStyles={{ width: "100%", marginTop: 3 }}
                      disabled={
                        projectInventoryOpsStore.inventoryRequestBody
                          .archived === 1 ||
                        !projectInventoryOpsStore.currentPoDetails
                          .raw_inward_in_progress ||
                        Boolean(
                          projectInventoryOpsStore.currentPoDetails
                            .raw_inward_qc_on_hold,
                        )
                      }
                    />
                  </Box>
                </Box>
              </Grid2>
            </Grid2>

            <Divider sx={{ mt: 5, mb: 5 }} />
            {projectInventoryOpsStore.currentPoDetails && (
              <>
                <Grid2
                  container
                  spacing={{ lg: 10, xs: 4 }}
                  columns={{ lg: 12, xs: 12 }}
                  sx={{
                    display: { xl: "flex", lg: "flex", md: "block" },
                    justifyContent: {
                      xl: "space-between",
                      lg: "space-between",
                    },
                  }}
                >
                  <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                    <Box>
                      <CustomTypography variant="heading5">
                        Size Mix
                      </CustomTypography>

                      <Box mt={2.5}>
                        <Box
                          sx={{
                            height: "21.5rem",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            overflowX: "auto",
                            padding: 4,
                            backgroundColor:
                              theme.palette.customColors.greyBackground,
                          }}
                        >
                          {projectInventoryOpsStore?.productDetailsBody
                            ?.size_mixes?.length > 0 ? (
                            projectInventoryOpsStore.productDetailsBody.size_mixes.map(
                              (item, index) => {
                                const [rawSize, ...colorParts] =
                                  item.sku?.split("-") || [];
                                const color = colorParts.join(" ");
                                const size =
                                  sizeLabelMap[
                                    rawSize?.toLowerCase() as keyof typeof sizeLabelMap
                                  ] || rawSize;

                                return (
                                  <Box
                                    key={index}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-evenly",
                                      paddingBottom: 3,
                                    }}
                                  >
                                    <CustomTypography
                                      variant="heading7"
                                      color={
                                        theme.palette.customColors.greyTextColor
                                      }
                                      style={{ flex: 1 }}
                                    >
                                      • {size} :
                                    </CustomTypography>

                                    <CustomTypography
                                      variant="heading7"
                                      color={
                                        theme.palette.customColors.greyTextColor
                                      }
                                      style={{
                                        flex: 0.9,
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {color}
                                    </CustomTypography>

                                    <CustomTypography
                                      variant="heading7"
                                      style={{ flex: 0.2, fontWeight: 600 }}
                                    >
                                      {String(item.quantity).padStart(2, "0")}
                                    </CustomTypography>
                                  </Box>
                                );
                              },
                            )
                          ) : (
                            <CustomTypography variant="heading7">
                              No Size Mix Data Available
                            </CustomTypography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Grid2>

                  <Grid2
                    size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                    mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
                  >
                    <Box>
                      <Box>
                        <CustomTypography
                          variant="heading5"
                          style={{
                            marginBottom: 20,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ marginRight: 1 }}>
                            <img
                              src={PrintOutwardicon}
                              alt="Raw Inward Icon"
                              style={{ width: 24, height: 24 }}
                            />
                          </Box>
                          Print Outward
                          <span
                            style={{
                              color: theme.palette.customColors.greyTextColor,
                              paddingLeft: "10px",
                            }}
                          >
                            {`(${
                              projectInventoryOpsStore.currentPoDetails
                                .print_outward_quantity || 0
                            }/
                        ${
                          projectInventoryOpsStore.currentPoDetails
                            .product_po_quantity || 0
                        })`}
                          </span>
                        </CustomTypography>

                        <CustomTypography
                          variant="heading6"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginBottom: 20 }}
                        >
                          Printer Name
                        </CustomTypography>
                        <AppSearchDropDown2
                          isMultiSelect={false}
                          title={"Select Printer"}
                          local={false}
                          borderColor={
                            theme.palette.customColors.greyDarkborder
                          }
                          handleSearch={(searchText) => {
                            shipmentStore.getDeliveryPartner(
                              searchText,
                              false,
                              true,
                            );
                          }}
                          list={shipmentStore.deliveryPartners.map((item) => {
                            return {
                              id: String(item.delivery_partner_id),
                              value: item.delivery_partner_name!,
                            };
                          })}
                          handleSelect={(selectedVendor: FilterValue[]) => {
                            if (
                              selectedVendor.length > 0 &&
                              selectedVendor[0].id !== undefined
                            ) {
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_print_outward_printer_id: Number(
                                  selectedVendor[0].id,
                                ),
                              });
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_print_outward_printer_name:
                                  selectedVendor[0].value,
                              });
                            } else {
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_print_outward_printer_id: null,
                              });
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_print_outward_printer_name: null,
                              });
                            }
                          }}
                          value={
                            projectInventoryOpsStore.currentPoDetails
                              .temp_print_outward_printer_id
                              ? [
                                  {
                                    id: String(
                                      projectInventoryOpsStore.currentPoDetails
                                        .temp_print_outward_printer_id,
                                    ),
                                    value: String(
                                      projectInventoryOpsStore.currentPoDetails
                                        .temp_print_outward_printer_name,
                                    ),
                                  },
                                ]
                              : undefined
                          }
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore?.currentPoDetails
                              ?.raw_inward_id
                          }
                        />

                        <CustomTypography
                          variant="heading6"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginBottom: 20, marginTop: 30 }}
                        >
                          Quantity Sent
                        </CustomTypography>
                        <CustomTextField
                          allowDecimalValue={false}
                          allowNegativeValue={false}
                          borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                          value={
                            projectInventoryOpsStore.currentPoDetails
                              .temp_print_outward_quantity || ""
                          }
                          placeholder="00"
                          width="100%"
                          onChange={(e) => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_outward_quantity: Number(
                                e.target.value,
                              ),
                            });
                          }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore?.currentPoDetails
                              ?.raw_inward_id
                          }
                        />

                        <CustomTypography
                          variant="heading6"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginBottom: 20, marginTop: 30 }}
                        >
                          Print Due Date
                        </CustomTypography>
                        <DatePicker2
                          key={`print_due_date_${
                            projectInventoryOpsStore.currentPoDetails
                              .temp_print_outward_timeline
                              ? projectInventoryOpsStore.currentPoDetails.temp_print_outward_timeline.getTime()
                              : "null"
                          }`}
                          borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                          onChange={(date) => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_outward_timeline: date?.toDate(),
                            });
                          }}
                          label=""
                          value={
                            projectInventoryOpsStore?.currentPoDetails
                              ?.temp_print_outward_timeline
                              ? dayjs(
                                  projectInventoryOpsStore.currentPoDetails
                                    .temp_print_outward_timeline,
                                )
                              : null
                          }
                          require={false}
                          error={false}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore?.currentPoDetails
                              ?.raw_inward_id
                          }
                        />
                      </Box>
                      <Box>
                        <AppButton
                          label="Save Details"
                          onClick={() => {
                            savePrintOutward();
                          }}
                          fontSize="1rem"
                          variant="primary"
                          customStyles={{ width: "100%", marginTop: 4 }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required
                          }
                        />
                      </Box>
                    </Box>
                  </Grid2>
                </Grid2>

                <Divider sx={{ mt: 5, mb: 5 }} />

                <Grid2
                  container
                  spacing={{ lg: 10, xs: 4 }}
                  columns={{ lg: 12, xs: 12 }}
                  sx={{
                    display: { xl: "flex", lg: "flex", md: "block" },
                    justifyContent: {
                      xl: "space-between",
                      lg: "space-between",
                    },
                  }}
                >
                  <Grid2 size={{ xl: 4.3, lg: 5, md: 12, xs: 12 }}>
                    {projectInventoryOpsStore.productDetailsBody?.mockups
                      ?.length > 0 ? (
                      <Box>
                        <CustomTypography variant="heading5">
                          Product Mockup
                        </CustomTypography>

                        <ImageCarousel
                          images={
                            projectInventoryOpsStore.productDetailsBody.mockups
                          }
                        />
                      </Box>
                    ) : (
                      <Box>
                        <CustomTypography variant="heading5">
                          Product Mockup
                        </CustomTypography>

                        <Box mt={2.5}>
                          <Box
                            sx={{
                              height: "24rem",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor:
                                theme.palette.customColors.greyBackground,
                            }}
                          >
                            <CustomTypography variant="heading6">
                              No image available
                            </CustomTypography>
                          </Box>
                        </Box>
                      </Box>
                    )}

                    <ImageGalleryWithDialog
                      images={
                        projectInventoryOpsStore?.currentPoDetails
                          ?.print_inward_qc_images
                      }
                      onImageClick={() =>
                        setIsPopupGalleryOpen(!isPopupGalleryOpen)
                      }
                      title="2nd QC Images"
                      imageKey="image_url"
                      idKey="id"
                      initialVisibleCount={3}
                      emptyMessage="QC IMAGES NOT FOUND"
                    />

                    <PopupGallery
                      key={"printInwardQc"}
                      open={isPopupGalleryOpen}
                      onClose={() => setIsPopupGalleryOpen(false)}
                      images={
                        projectInventoryOpsStore?.currentPoDetails?.print_inward_qc_images?.map(
                          (img) => ({ id: img.id, src: img.image_url }),
                        ) || []
                      }
                      title={"2nd QC Images"}
                      handleDeleteImage={(id) => {
                        projectInventoryOpsStore.deletePrintInwardQCImg(id);
                      }}
                    />
                  </Grid2>

                  <Grid2
                    size={{ xl: 7.7, lg: 7, md: 12, xs: 12 }}
                    mt={{ xl: 0.5, lg: 0, md: 2, sm: 2, xs: 2 }}
                  >
                    <Box sx={{ marginBottom: 5 }}>
                      <Box>
                        <Box display={"flex"} justifyContent={"space-between"}>
                          <CustomTypography
                            variant="heading5"
                            style={{
                              marginBottom: 20,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box sx={{ marginRight: 1 }}>
                              <img
                                src={PrintInwardicon}
                                alt="Raw Inward Icon"
                                style={{ width: 24, height: 24 }}
                              />
                            </Box>
                            Print Inward
                            <span
                              style={{
                                color: theme.palette.customColors.greyTextColor,
                                paddingLeft: "10px",
                              }}
                            >
                              {`(${
                                projectInventoryOpsStore.currentPoDetails
                                  .print_inward_quantity || 0
                              }/
                        ${
                          projectInventoryOpsStore.currentPoDetails
                            .product_po_quantity || 0
                        })`}
                            </span>
                          </CustomTypography>

                          <Box display={"flex"} alignItems={"center"} gap={2}>
                            <AppButton
                              label={
                                projectInventoryOpsStore.currentPoDetails
                                  ?.print_inward_mark_received
                                  ? "Received"
                                  : "Received"
                              }
                              variant="primary"
                              onClick={() => savePrintInwardDetails(true)}
                              customStyles={{
                                fontSize: "14px",
                                textTransform: "none",
                                maxHeight: "28px",
                                minHeight: "28px",
                                backgroundColor: projectInventoryOpsStore
                                  .currentPoDetails?.print_inward_mark_received
                                  ? theme.palette.customColors.greenLight
                                  : "",
                              }}
                              disabled={
                                projectInventoryOpsStore.inventoryRequestBody
                                  .archived === 1 ||
                                projectInventoryOpsStore?.currentPoDetails
                                  ?.print_inward_mark_received ||
                                !projectInventoryOpsStore?.productDetailsBody
                                  ?.product?.customisation_required ||
                                (projectInventoryOpsStore?.currentPoDetails
                                  ?.print_inward_quantity || 0) -
                                  (projectInventoryOpsStore?.currentPoDetails
                                    ?.print_inward_rejection_quantity || 0) >=
                                  (projectInventoryOpsStore?.currentPoDetails
                                    ?.product_po_quantity || 0)
                              }
                            />

                            <Box>
                              <AppButton
                                key={
                                  projectInventoryOpsStore.currentPoDetails
                                    .print_inward_qc_on_hold
                                    ? "resume_print_inward_qc"
                                    : projectInventoryOpsStore.currentPoDetails
                                          .print_inward_in_progress
                                      ? "hold_print_inward_qc"
                                      : "start_print_inward_qc"
                                }
                                label={
                                  projectInventoryOpsStore.currentPoDetails
                                    .print_inward_qc_on_hold
                                    ? "Resume QC"
                                    : projectInventoryOpsStore.currentPoDetails
                                          .print_inward_in_progress
                                      ? "Hold QC"
                                      : "Start QC"
                                }
                                variant="primary"
                                onClick={handleStartStopPrintInwardQc}
                                customStyles={{
                                  right: "4px",
                                  fontSize: "14px",
                                  textTransform: "none",
                                  maxHeight: "28px",
                                  minHeight: "28px",
                                }}
                                disabled={
                                  projectInventoryOpsStore.inventoryRequestBody
                                    .archived === 1 ||
                                  !projectInventoryOpsStore?.productDetailsBody
                                    ?.product?.customisation_required
                                }
                              />
                            </Box>
                            <Box>
                              {/* <AppButton
                                key={"print_inward_qc_invoice_details"}
                                label={"Invoice Details"}
                                variant="primary"
                                onClick={() =>
                                  fetchVendorInvoices(
                                    projectInventoryOpsStore.currentPoDetails
                                      .print_inward_id,
                                    VendorInvoiceType.PRINT_INWARD
                                  )
                                }
                                customStyles={{
                                  right: "4px",
                                  fontSize: "14px",
                                  textTransform: "none",
                                  maxHeight: "28px",
                                  minHeight: "28px",
                                }}
                                disabled={
                                  projectInventoryOpsStore.currentPoDetails
                                    ?.print_inward_id === undefined ||
                                  projectInventoryOpsStore.inventoryRequestBody
                                    .archived === 1
                                }
                              /> */}
                            </Box>
                          </Box>
                        </Box>
                        <CustomTypography
                          variant="heading6"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginBottom: 15 }}
                        >
                          Quantity Received
                        </CustomTypography>

                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            marginBottom: 2,
                          }}
                        >
                          <CustomTextField
                            allowDecimalValue={false}
                            allowNegativeValue={false}
                            borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                            value={
                              projectInventoryOpsStore.currentPoDetails
                                .temp_print_inward_quantity || ""
                            }
                            placeholder="00"
                            width="100%"
                            type="number"
                            onChange={(e) => {
                              projectInventoryOpsStore.updateCurrentPoDetails({
                                temp_print_inward_quantity: Number(
                                  e.target.value,
                                ),
                              });
                            }}
                            disabled={
                              projectInventoryOpsStore.inventoryRequestBody
                                .archived === 1 ||
                              !projectInventoryOpsStore?.productDetailsBody
                                ?.product?.customisation_required
                            }
                          />
                        </Box>
                      </Box>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 2,
                            marginTop: 5,
                            marginBottom: 3,
                          }}
                        >
                          <Box>
                            <CustomTypography
                              variant="heading5"
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <Box sx={{ marginRight: 1 }}>
                                <img
                                  src={QCrejectionIcon2}
                                  alt="Raw Inward Icon"
                                  style={{ width: 24, height: 24 }}
                                />
                              </Box>
                              2nd QC Rejection
                              <span
                                style={{
                                  color:
                                    theme.palette.customColors.greyTextColor,
                                  paddingLeft: "10px",
                                }}
                              >
                                {`(${
                                  projectInventoryOpsStore.currentPoDetails
                                    .print_inward_rejection_quantity || 0
                                }/
                                ${
                                  projectInventoryOpsStore.currentPoDetails
                                    .product_po_quantity || 0
                                })`}
                              </span>
                            </CustomTypography>
                          </Box>
                        </Box>

                        <SingleInput
                          required={true}
                          multiline={true}
                          key={"print_inward_popup"}
                          buttonMarginTop={0}
                          open={openPrintInwardHoldPopup}
                          type="text"
                          heading="Hold QC"
                          content="Please provide a reason for holding the QC process (mandatory)."
                          onSubmit={(reason) => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_inward_qc_reason_for_hold: reason,
                            });
                            handleHoldPrintInwardQc();
                          }}
                          onClose={() => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_inward_qc_reason_for_hold: "",
                            });
                            setOpenPrintInwardHoldPopup(false);
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <CustomTypography
                            variant="heading6"
                            color={theme.palette.customColors.greyTextColor}
                            style={{ marginBottom: 15 }}
                          >
                            Quantity Rejected
                          </CustomTypography>
                        </Box>
                        <CustomTextField
                          allowDecimalValue={false}
                          allowNegativeValue={false}
                          type="number"
                          borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                          value={
                            projectInventoryOpsStore.currentPoDetails
                              .temp_print_inward_rejection_quantity || ""
                          }
                          placeholder="00"
                          width="100%"
                          onChange={(e) => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_inward_rejection_quantity: Number(
                                e.target.value,
                              ),
                            });
                          }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore.currentPoDetails
                              .print_inward_in_progress ||
                            Boolean(
                              projectInventoryOpsStore.currentPoDetails
                                .print_inward_qc_on_hold,
                            )
                          }
                        />
                        <CustomTypography
                          variant="heading6"
                          color={theme.palette.customColors.greyTextColor}
                          style={{ marginBottom: 18, marginTop: 20 }}
                        >
                          Rejection Reason
                        </CustomTypography>
                        <FormTextField
                          borderColor={`0.1px solid ${theme.palette.customColors.greyDarkborder}`}
                          multiline
                          id="temp_print_inward_rejection_reason"
                          value={
                            projectInventoryOpsStore.currentPoDetails
                              .temp_print_inward_rejection_reason || ""
                          }
                          sx={{
                            flexGrow: 1,
                            marginBottom: "0px",
                            "& .MuiInputBase-root": {
                              height: "100%",
                              alignItems: "start",
                              overflow: "auto",
                            },
                            "& .MuiInputBase-input": {
                              minHeight: "110px",
                              overflowY: "auto",
                              display: "block",
                            },
                          }}
                          placeholder="Add additional information"
                          onChange={(id, event) => {
                            projectInventoryOpsStore.updateCurrentPoDetails({
                              temp_print_inward_rejection_reason: event,
                            });
                          }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore.currentPoDetails
                              .print_inward_in_progress ||
                            Boolean(
                              projectInventoryOpsStore.currentPoDetails
                                .print_inward_qc_on_hold,
                            )
                          }
                        />

                        <AppButton
                          label={
                            <Box display={"flex"} alignItems="center">
                              <img
                                src={UploadIcon}
                                alt="Upload Icon"
                                style={{
                                  marginRight: 8,
                                  display:
                                    projectInventoryOpsStore
                                      .inventoryRequestBody.archived === 1 ||
                                    !projectInventoryOpsStore
                                      ?.productDetailsBody?.product
                                      ?.customisation_required ||
                                    !Boolean(
                                      projectInventoryOpsStore.currentPoDetails
                                        .print_inward_in_progress,
                                    )
                                      ? "none"
                                      : "",
                                }}
                              />
                              Upload Images
                            </Box>
                          }
                          onClick={() => setOpenPrintQcPopup(true)}
                          variant="primary"
                          customStyles={{ width: "100%", marginTop: 3 }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore.currentPoDetails
                              .print_inward_in_progress ||
                            Boolean(
                              projectInventoryOpsStore.currentPoDetails
                                .print_inward_qc_on_hold,
                            )
                          }
                        />
                        <ImageUploadDialog
                          open={openPrintQcPopup}
                          onClose={() => setOpenPrintQcPopup(false)}
                          onUpload={handleUpload2}
                          multiple={true}
                        />

                        <AppButton
                          label="Save Details/ Stop QC"
                          onClick={() => {
                            savePrintInwardDetails(false);
                          }}
                          fontSize="1rem"
                          variant="primary"
                          customStyles={{ width: "100%", marginTop: 3 }}
                          disabled={
                            projectInventoryOpsStore.inventoryRequestBody
                              .archived === 1 ||
                            !projectInventoryOpsStore?.productDetailsBody
                              ?.product?.customisation_required ||
                            !projectInventoryOpsStore.currentPoDetails
                              .print_inward_in_progress ||
                            Boolean(
                              projectInventoryOpsStore.currentPoDetails
                                .print_inward_qc_on_hold,
                            )
                          }
                        />
                      </Box>
                    </Box>
                  </Grid2>
                </Grid2>
              </>
            )}
          </>
        </Box>
      </Container>

      {/* Invoice Information Popup */}
      {selectedInwardId && selectedInvoiceType && (
        <InvoiceInformationPopup
          inwardId={selectedInwardId}
          type={selectedInvoiceType}
          open={isInvoicePopupOpen}
          onClose={handleCloseInvoicePopup}
          onSaveInvoiceDetails={handleSaveInvoiceDetails}
        />
      )}
    </>
  );
};

export default observer(InventoryOpsDetails);
